import { Component, computed, input, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DomSanitizer } from "@angular/platform-browser";

import { LoadingSectionComponent } from "../loading-section/loading-section.component";

@Component({
  selector: "app-power-bi-dashboard",
  imports: [CommonModule, LoadingSectionComponent],
  templateUrl: "./power-bi-dashboard.component.html",
  styleUrl: "./power-bi-dashboard.component.scss",
})
export class PowerBiDashboardComponent {
  readonly dashboardUrl = input.required<string>();
  readonly title = input<string>("Power BI Dashboard");

  readonly isLoading = signal(true);

  private readonly sanitizer: DomSanitizer;

  readonly sanitizedUrl = computed(() =>
    this.sanitizer.bypassSecurityTrustResourceUrl(this.dashboardUrl()),
  );

  constructor(sanitizer: DomSanitizer) {
    this.sanitizer = sanitizer;
  }

  onIframeLoad(): void {
    this.isLoading.set(false);
  }
}
